import { SharedModule } from './../shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER} from '@angular/core';
import { AppConfig } from './app-init';

import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { AppRoutingModule } from './app-routing.module';
import { FunFactsModalModule } from '../shared/modules/fun-facts-modal/fun-facts-modal.module';
import { MediaModalModule } from '../shared/modules/media-modal/media-modal.module';
import { WOAReqInterceptor } from '../shared/utilities/http.interceptor';
import { CookieUtil } from '../shared/utilities/cookie.utils';
import { EndPointUtils } from '../shared/utilities/end-points.utils';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HTTP_INTERCEPTORS,  HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Angulartics2Module } from 'angulartics2';
import { Angulartics2RouterlessModule } from 'angulartics2/routerlessmodule';

// services
import { UsageService } from './services/usage.service';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent
  ],
  imports: [
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FunFactsModalModule,
    MediaModalModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    Angulartics2Module.forRoot(),
    Angulartics2RouterlessModule.forRoot()
  ],
  providers: [
    UsageService,
    CookieUtil,
    EndPointUtils,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WOAReqInterceptor,
      multi: true
    },
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: (config: AppConfig) => () => config.load(),
      multi: true,
      deps: [AppConfig]
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
export function HttpLoaderFactory(http: HttpClient) {
  const url = window.location.origin + '/comparison-tool/assets/i18n/';
  return new TranslateHttpLoader(http, url);
}
